import parseAccountInfo from 'lib/parseAccountInfo';
import gigya from 'api/gigya';
import * as analytics from 'analytics';
import { playbackModes } from 'store/reducers/player';
import { accountInfoLoaded } from 'actions/lifecycle-actions';
import { showNotification } from 'actions/notifications-actions';
import { isHDsupported, isIE11andLower } from 'util/device';
import { GIGYA_DEFAULT_JUKE_BRAND_IMAGE } from 'globalConst/gigya-const';
import { NotificationTypes, NotificationTexts } from '../components/Notifications/Notification';
import { gigyaActions } from './actions-const';
import { playLiveAudio } from './player-actions';
import logger from 'util/logger';

export function attemptLogin(autoPlayAfterLogin = false) {
  return (dispatch) => {
    dispatch({ type: gigyaActions.ATTEMPT_LOGIN, autoPlayAfterLogin });
  };
}

export function setUserHDPreference(prefersHD, trackAnalytics = true, autoplay = false) {
  return (dispatch, getState) => {
    const {
      user: { isLoggedIn },
      player: { currentStation, playbackMode },
    } = getState();

    if (trackAnalytics) {
      analytics.trackHDPreference(prefersHD);
    }

    if (isLoggedIn) {
      // Update Gigya Settings
      gigya.setAccountInfo({
        data: { radio_juke_prefers_hd: prefersHD },
        callback: (response) => response.status === 'FAIL' && logger.warn(response.statusMessage),
      });
    }

    dispatch({
      type: gigyaActions.PREFERS_HD_SOURCES,
      payload: prefersHD,
    });

    if (
      autoplay &&
      prefersHD &&
      currentStation &&
      currentStation.tritonMountHD &&
      playbackMode === playbackModes.LIVE_AUDIO
    ) {
      dispatch(playLiveAudio());
    }
  };
}

export function login(accountInfo) {
  return (dispatch, getState) => {
    const {
      user,
      player: { currentStation, playbackMode },
    } = getState();
    dispatch({
      type: gigyaActions.LOGIN,
      accountInfo,
    });

    dispatch(accountInfoLoaded());

    const prefersHD = user.prefersHDSources || accountInfo.data.radio_juke_prefers_hd;
    if (user.prefersHDSources) {
      // Update Gigya accountInfo
      gigya.setAccountInfo({
        data: { radio_juke_prefers_hd: true },
        callback: (response) => response.status === 'FAIL' && logger.warn(response.statusMessage),
      });
    } else if (accountInfo.data.radio_juke_prefers_hd && isHDsupported()) {
      dispatch(setUserHDPreference(true, false));
    }

    // Start HD Stream
    if (
      prefersHD &&
      user.attemptingLogin && // Only start stream if user preeviously interacted with website
      currentStation &&
      currentStation.tritonMountHD &&
      playbackMode === playbackModes.LIVE_AUDIO &&
      user.autoPlayAfterLogin
    ) {
      dispatch(playLiveAudio());
    }
  };
}

export function updateProfile(accountInfo) {
  return (dispatch) => {
    dispatch({
      type: gigyaActions.UPDATE_PROFILE,
      accountInfo,
    });
  };
}

export function loadAccountInfo() {
  return (dispatch) => {
    dispatch({ type: gigyaActions.ACCOUNT_INFO_LOADING });
    gigya.getAccountInfo({
      callback: (response) => {
        if (response.status === 'FAIL' && response.errorCode === 403005) {
          dispatch({ type: gigyaActions.NOT_LOGGED_IN });
          dispatch(accountInfoLoaded());
        } else if (response.status === 'OK' && response.errorCode === 0) {
          dispatch(login(parseAccountInfo(response)));
        } else {
          logger.error('getAccountInfo > Unexpected errorCode', response);
          dispatch(accountInfoLoaded());
        }
      },
    });
  };
}

export function logout() {
  gigya.clearGigyaToken();

  return (dispatch, getState) => {
    const {
      user,
      player: { isPlaying, currentStation, playbackMode },
    } = getState();
    dispatch(
      showNotification({
        type: NotificationTypes.NOTIFICATION,
        message: NotificationTexts.LOGOUT_SUCCESS,
      })
    );

    dispatch({ type: gigyaActions.LOGOUT });

    if (user.prefersHDSources) {
      dispatch(setUserHDPreference(false, false));
      // Switch to SD stream
      if (isPlaying && currentStation && currentStation.tritonMountHD && playbackMode === playbackModes.LIVE_AUDIO) {
        dispatch(playLiveAudio());
      }
    }
  };
}

export function removeBrandImageFromExistingModal() {
  // Remove background-image from IE
  const [brandImageElementIE] = document.getElementsByClassName('talpa-meer__brand-background-image') || [];
  if (brandImageElementIE) {
    brandImageElementIE.style.backgroundImage = '';
  }

  // Remove src from non-IE browsers
  const [brandImageElement] = document.getElementsByClassName('talpa-meer__brand-image') || [];
  if (brandImageElement) {
    brandImageElement.src = '';
  }
}

export function showTalpaGigyaModal(customImage = '', forceScreen = 'login', autoPlayAfterLogin = false) {
  removeBrandImageFromExistingModal();

  return (dispatch) => {
    dispatch(attemptLogin(autoPlayAfterLogin));

    const talpaGigyaModal = document.querySelector('talpa-meer-single-sign-on');

    talpaGigyaModal.config = {
      ...talpaGigyaModal.config,
      brandImage: customImage,
    };

    /**
     * Temp fix for changing brand image in modal
     */

    if (isIE11andLower) {
      const [brandImageElementIE] = document.getElementsByClassName('talpa-meer__brand-background-image') || [];
      if (customImage && brandImageElementIE) {
        brandImageElementIE.style.backgroundImage = `url(${customImage})`;
      } else if (brandImageElementIE) {
        brandImageElementIE.style.backgroundImage = `url(${GIGYA_DEFAULT_JUKE_BRAND_IMAGE})`;
      }
    } else {
      const [brandImageElement] = document.getElementsByClassName('talpa-meer__brand-image') || [];
      if (customImage && brandImageElement) {
        brandImageElement.src = customImage;
      } else if (brandImageElement) {
        brandImageElement.src = GIGYA_DEFAULT_JUKE_BRAND_IMAGE;
      }
    }

    talpaGigyaModal.show(forceScreen);
  };
}
